export default "__VITE_ASSET__CjTM7YC8__"